import { useMediaQuery } from '@mui/material';

const MOBILE_MEDIA_QUERY = '(max-width:480px)';

/**
 * 스크린 타입을 반환합니다.
 */
export const useScreenType = () => {
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);
  return isMobile ? 'mobile' : 'desktop';
};
